
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { companyStore, mainStore, leagueStore } from '@/store';
import { ILeagueEntry } from '@/interfaces/league';

@Component
export default class Edit extends Vue {
  @Prop({ type: Number, default: 0 }) readonly propId;
  @Prop({ type: Number, default: 0 }) readonly propStatus;
  public isLoading = false;
  public league_entry = [];
  public grupo_entry = 0;
  public nome_fantasia = '';
  public status_entry = '';
  public company_id = 0;
  public created_at = '';

  get grupoEntry() {
    return [
      {
        id: 1,
        descricao: 'Compacta',
      },
      {
        id: 2,
        descricao: 'Plena',
      },
      {
        id: 3,
        descricao: 'Master',
      },
    ];
  }

  get statusEntry() {
    return [
      {
        id: 'A',
        descricao: 'Ativo',
      },
      {
        id: 'I',
        descricao: 'Inativo',
      },
    ];
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async handleEditEntry() {
    this.isLoading = true;

    let league_entry: ILeagueEntry = {
      league_id: 2,
      company_id: this.company_id,
      user_id: this.currentUser?.id,
      grupo: this.grupo_entry,
      status: this.status_entry,
    };

    league_entry['id'] = this.propId;

    const leagueEntry = await leagueStore.leagueEntryUpdate(league_entry);

    if (leagueEntry.id > 0) {
      this.$swal.fire('Inscrição salva com sucesso!', '', 'success');
    } else {
      this.$swal.fire('Falha ao salvar a inscrição.', 'Tente novamente mais tarde!', 'error');
    }
    this.$emit('getPropStatus', Math.floor(Math.random() * 200));
    this.isLoading = false;
  }

  public async mounted() {
    this.isLoading = true;
    this.league_entry = await leagueStore.getLeagueEntryId(this.propId);
    this.nome_fantasia = this.league_entry[0]['nome_fantasia'];
    this.grupo_entry = this.league_entry[0]['grupo'];
    this.status_entry = this.league_entry[0]['status_liga'];
    this.created_at = this.league_entry[0]['created_at'];
    this.company_id = this.league_entry[0]['company_id'];
    this.isLoading = false;
  }
}
